import { useRef } from "react";

import {
  homepageImageUrl,
  homepageVideoPosterUrl,
  homepageVideoUrl,
  type HomepageMotionContent,
} from "@/data/homepageContent";
import { useMotionCoverSplit } from "./useMotionCoverSplit";
import styles from "./MotionSystemSection.module.scss";

type MotionSystemSectionProps = {
  content: HomepageMotionContent;
};

export function MotionSystemSection({ content }: MotionSystemSectionProps) {
  const sectionRef = useRef<HTMLDivElement | null>(null);
  const shellRef = useRef<HTMLDivElement | null>(null);
  const topPanelRef = useRef<HTMLDivElement | null>(null);
  const bottomPanelRef = useRef<HTMLDivElement | null>(null);
  const topImageRef = useRef<HTMLImageElement | null>(null);
  const bottomImageRef = useRef<HTMLImageElement | null>(null);
  const videoShellRef = useRef<HTMLDivElement | null>(null);
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useMotionCoverSplit({
    sectionRef,
    shellRef,
    topPanelRef,
    bottomPanelRef,
    topImageRef,
    bottomImageRef,
    videoShellRef,
    videoRef,
  });

  return (
    <div className={styles.motionSystem} ref={sectionRef}>
      <div className={styles.coverImageShell} ref={shellRef} aria-hidden="true">
        <div className={styles.coverHalfTop} ref={topPanelRef}>
          <img
            ref={topImageRef}
            src={homepageImageUrl(content.cover_image)}
            alt=""
            className={`${styles.coverImage} ${styles.coverImageTop}`}
          />
        </div>

        <div className={styles.coverHalfBottom} ref={bottomPanelRef}>
          <img
            ref={bottomImageRef}
            src={homepageImageUrl(content.cover_image)}
            alt=""
            className={`${styles.coverImage} ${styles.coverImageBottom}`}
          />
        </div>
      </div>

      <div className={styles.videoShell} ref={videoShellRef}>
        <video
          ref={videoRef}
          className={styles.video}
          src={homepageVideoUrl(content.video)}
          poster={homepageVideoPosterUrl(content.video)}
          autoPlay
          muted
          playsInline
          loop
          preload="auto"
        />
      </div>
    </div>
  );
}
